// Central place for public-facing company contact details.
// Update in one place → reflects across the whole site.

export const COMPANY = {
  name: "Campusco (Pty) Ltd.",
  emailInfo: "info@thecampusco.co.za",
  website: "www.thecampusco.co.za",
  phoneDisplay: "060 836 2116",
  // E.164 for tel: links and WhatsApp (no leading zero, prefix +27)
  phoneIntl: "+27608362116",
  phoneWhatsApp: "27608362116",
  address: {
    line1: "2 Bruton Road, Bryanston, 2191",
    line2: "Johannesburg, South Africa",
  },
  hoursShort: "Mon–Fri: 08h00 – 17h00 · Sat by appointment",
};

export const whatsappHref = (message = "Hi Campusco, I'd like to know more about your student accommodation services.") =>
  `https://wa.me/${COMPANY.phoneWhatsApp}?text=${encodeURIComponent(message)}`;
